import { render, staticRenderFns } from "./ProductionHistory.vue?vue&type=template&id=5b6066fa&scoped=true&"
import script from "./ProductionHistory.vue?vue&type=script&lang=js&"
export * from "./ProductionHistory.vue?vue&type=script&lang=js&"
import style0 from "./ProductionHistory.vue?vue&type=style&index=0&id=5b6066fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6066fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCheckbox,VPagination,VTextField})
